module.exports = __webpack_public_path__ + "static/media/pluralsight.3d41e74d.webp";